export enum CheckoutType {
  CBE = 'CBE',
  FOOD = 'FOOD',
  DEFAULT = 'DEFAULT',
}

export const checkoutTypeEnum = {
  CBE: 'CBE',
  FOOD: 'FOOD',
  DEFAULT: 'DEFAULT',
}

export const checkoutTypeEnumFullName = {
  CBE: 'OrderCheckoutTypeEnum.CBE',
  FOOD: 'OrderCheckoutTypeEnum.FOOD',
  DEFAULT: 'OrderCheckoutTypeEnum.DEFAULT',
}
